import { render, staticRenderFns } from "./professionalsByInsuranceReport.vue?vue&type=template&id=3a35b668"
import script from "./professionalsByInsuranceReport.vue?vue&type=script&lang=js"
export * from "./professionalsByInsuranceReport.vue?vue&type=script&lang=js"
import style0 from "./professionalsByInsuranceReport.vue?vue&type=style&index=0&id=3a35b668&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports